/* Verolae · FAQ updated — accordion behaviour ported from the product-page FAQ section
   script. Toggles `.is-open` on the card (CSS animates grid-template-rows), keeps
   aria-expanded / aria-hidden in sync and closes the other cards first. */
(function () {
  'use strict';

  function setState(item, open) {
    var btn = item.querySelector('.faq-btn');
    var answer = item.querySelector('.faq-answer');
    if (open) {
      item.classList.add('is-open');
    } else {
      item.classList.remove('is-open');
    }
    if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (answer) answer.setAttribute('aria-hidden', open ? 'false' : 'true');
  }

  function initFaq(sectionEl) {
    if (!sectionEl || sectionEl.dataset.verolaeFaqReady === 'true') return;
    sectionEl.dataset.verolaeFaqReady = 'true';

    var items = Array.prototype.slice.call(sectionEl.querySelectorAll('.faq-item'));

    items.forEach(function (item) {
      var btn = item.querySelector('.faq-btn');
      if (!btn) return;

      btn.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');

        /* Accordion: close all others first */
        items.forEach(function (other) {
          if (other !== item) setState(other, false);
        });

        setState(item, !isOpen);
      });
    });
  }

  function initAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    Array.prototype.forEach.call(scope.querySelectorAll('[data-verolae-faq-updated]'), initFaq);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  /* Theme editor: initialise re-rendered sections and reveal the selected block */
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
  document.addEventListener('shopify:block:select', function (event) {
    var item = event.target && event.target.closest ? event.target.closest('.faq-item') : null;
    if (!item || !item.closest('[data-verolae-faq-updated]')) return;
    if (!item.classList.contains('is-open')) {
      var btn = item.querySelector('.faq-btn');
      if (btn) btn.click();
    }
  });
})();
